module.exports = __webpack_public_path__ + "static/img/无指手套.f8bd8f07.jpg";